import PaginationFootballProperties from "./PaginationFootballProperties";

export default class MetaFootballModel {
    public pagination: PaginationFootballProperties = new PaginationFootballProperties();
}